import { render, staticRenderFns } from "./OnAir.vue?vue&type=template&id=70dc2a6d&scoped=true"
import script from "./OnAir.vue?vue&type=script&lang=js"
export * from "./OnAir.vue?vue&type=script&lang=js"
import style0 from "./OnAir.vue?vue&type=style&index=0&id=70dc2a6d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70dc2a6d",
  null
  
)

export default component.exports